/**
 * Renderer for the current value of an asset tag inventory model.
 * If the current value of the tag has been edited, it will be displayed muted.
 * If the current value is new, we display a "New" tag since the current value is blank and not yet saved.
 */
import React from 'react';
import { Tag, Text } from 'core/components';
import AssetTagInventoryModel from 'app/stores/assetTags/AssetTagInventoryModel';

interface Props {
  model: AssetTagInventoryModel;
  value: boolean;
}

function currentValueRenderer({ model, value: edited }: Props) {
  return (
    <>
      <Text opacity={edited ? 0.3 : 1}>{model.get('value')}</Text>
      {model.isNewValue && <Tag intent="primary">New</Tag>}
    </>
  );
}

export default currentValueRenderer;
